module.exports = __webpack_public_path__ + "static/media/birthdayCake.ae348915.svg";